export const getLocationSummaryUrl =
  "/api/v1/summary/geo/near?lat=:lat&lng=:lng&radius=:radius";
